import type { Being, BeingState } from '../../../models/Being';
import type { Surroundings } from '../../../models/Surroundings';
import { AI } from '../../../models/constants';
import type { IBeingState } from './IBeingState';

export class EatingState implements IBeingState {
    static readonly stateName = 'Eating';

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(being: Being, surroundings: Surroundings): boolean {
        return being.health < AI.HUNGER_THRESHOLD && surroundings.availableFood > 0;
    }

    tick(being: Being, surroundings: Surroundings): BeingState {
        if (surroundings.availableFood <= 0) {
            return 'Exploring';
        }

        being.setHealth(being.health + surroundings.availableFood);

        if (being.health >= AI.FULL_THRESHOLD) {
            being.restTicks = AI.REST_TICKS;
            return 'Resting';
        }

        return EatingState.stateName;
    }
}
